module.exports = {
  externalPayProviderSelector: {
    label: 'Elektronik transfer yönteminizi seçin:',
  },
  paymentMethodInfo: {
    achpse: 'Fonların borçlandırılmasını yetkilendirmek için seçtiğiniz bankanın web sitesine yönlendirileceksiniz. Tasarruf, vadesiz veya elektronik mevduat hesapları için kullanılabilir.',
    bancolombia: 'Vadesiz ve tasarruf hesapları için kullanılabilir. Bu ödeme yöntemini seçerek Bancolombia web sitesine yönlendirileceksiniz.',
  },
  fawryLabel: 'Fawry ile öde',
};
